module.exports = __webpack_public_path__ + "img/SoundOnButtonNew.1afda73a.png";